/* esm.sh - applesauce-common@5.2.0/dist/models/stream */
export * from "/*applesauce-common@5.2.0/esnext/dist/models/stream.mjs";
